$.fn.hideloader = function () {
    this.css('height', 0);
    setTimeout(() => this.children().hide(), 200);
}
$.fn.showloader = function () {
    this.css('height', '100vh');
    this.children().show();
}

let table_config = {
    scrollX: true,
    searching: false,
    processing: true,
    pagingType: 'full_numbers',
    pageLength: 10,
    bLengthChange: false,
    language: {
        emptyTable: '無資料',
        paginate: {
            first: '第一頁',
            last: '最末頁',
            next: '下一頁',
            previous: '上一頁'
        },
        info: "第 _START_ 至 _END_ 筆，總共 _TOTAL_ 筆",
        infoEmpty: "0 筆資料"
    },
    drawCallback: function (oSettings) {
        var totalPages = this.api().page.info().pages;
        if (totalPages <= 1) {
            $(`#${$(this).attr('id')}_paginate`).hide();
        } else {
            $(`#${$(this).attr('id')}_paginate`).show();
        }
    }
}

const swalBtn = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-danger mx-1",
        cancelButton: "btn btn-secondary mx-1"
    },
    buttonsStyling: false
});

$(document).on('collapsed-done.lte.pushmenu', () => {
    DataTable.tables({ visible: true, api: true }).columns.adjust();
})
$(document).on('shown.lte.pushmenu', () => {
    setTimeout(() => DataTable.tables({ visible: true, api: true }).columns.adjust(), 300);
})

$(document).ready(function () {
    $("input:disabled").attr('size', function () {
        return $(this).val().length;
    })
});

/**
  * 掃描條碼-Enter 即觸發按鈕
  */
$(document).ready(function () {
    $("input[aria-describedby]").on("keypress", function (event) {
        if (event.key === "Enter") {
            const btnId = $(this).attr('aria-describedby')
            $(`#${btnId}`).trigger('click');
        }
    });
});